<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
    import StatusBadge from '../common/StatusBadge.svelte';
    export let item = null;
</script>

<style>
    .wrapper {
        display: flex;
        border-bottom: 1px solid #dddddd;
        padding: 5px;
    }

</style>

<div class="wrapper">
    <StatusBadge status={item.template_status}/>
    <div> - <a href={`${PATH_PREFIX}/sw/builder/activity_sequence_builder/${item.id}/`} target="_blank" rel="noopener noreferrer">{item.name}</a></div>
</div>
